import { MissionEventHandler } from "../mission"
import { bindData, byId, formatNumber } from "../utils"
import * as sparkline from "../sparkline"
import { slantDistance } from "../utils"
import * as adminFeed from '../adminFeed'

const HISTORY_COUNT = 50

const templateNode = byId("radioCard")

export default class RadioCard extends MissionEventHandler {
  constructor(mission, device, parent) {
    super(mission)

    this.device = device
    this.radioNode = templateNode.content.firstElementChild.cloneNode(true)
    this.radioNode.classList.add("simple")
    this.extendedNode = this.radioNode.getElementsByClassName("extendedInfo")[0]
    this.radioNode.querySelector(".expandLine a").addEventListener("click", (event) => {
      this.toggleExpand()
    })
    this.headerNode = this.radioNode.getElementsByTagName("header")[0]
    this.history = []
    this.expanded = false

    bindData(this.device, this.radioNode)
    const img = this.radioNode.getElementsByTagName("img")[0]
    img.src = device.type === "ARS" ? '/images/Active ARS.png' : '/images/Inactive GRS.png'
    parent.appendChild(this.radioNode)

    if (this.mission.initialSync) this.setLead(this.mission.initialSync.roam.currentId == this.device.id)

    this.handleDeviceUpdated = this.handleDeviceUpdated.bind(this)
    adminFeed.register('device', device.id, this.handleDeviceUpdated)

    // Click to center map on radio
    this.radioNode.addEventListener("click", () => {
      if (this.device && typeof(this.device.latitude) === "number") {
        mymap.flyTo(L.latLng(this.device.latitude, this.device.longitude))
      }
    })
  }

  handleDeviceUpdated(message) {
    this.device = message.device
    bindData(this.device, this.headerNode)
  }

  toggleExpand() {
    if (this.expanded) {
      this.radioNode.classList.remove("expanded")
      this.expanded = false
    } else {
      this.radioNode.classList.add("expanded")
      this.expanded = true
    }

    this.update()
  }

  setLead(isLead) {
    if (this.device.type === "ARS") return

    if (isLead) {
      this.radioNode.classList.add("radio-selected")
    } else {
      this.radioNode.classList.remove("radio-selected")
    }
  }

  getRSSI(data) {
    const radios = this.device.type === "ARS" ? data.data.remote.radio : data.data.local.radio
    if (data.data.remote.protocol.radioStatus !== 3 && data.data.local.protocol.radioStatus !== 3) return -130
    return Math.max(radios[0].avgRSSI, radios[1].avgRSSI)
  }

  updateExpanded() {
    let historyData = this.history.reduce( (prev, entry) => {
      const dev = this.device.type === "ARS" ? entry.data.remote : entry.data.local
      prev.primary.push(dev.radio[0].avgRSSI)
      prev.secondary.push(dev.radio[1].avgRSSI)
      prev.sats.push(dev.position.gpsSatellites)
      prev.altitude.push(dev.position.gnssAltitude)
      prev.txBytes.push(dev.protocol.txByteTotal)
      prev.rxBytes.push(dev.protocol.rxByteTotal)
      prev.slant.push(slantDistance(entry.data.remote, entry.data.local))
      return prev
    }, {
      primary:[],
      secondary:[],
      sats:[],
      altitude:[],
      txBytes:[],
      rxBytes:[],
      slant:[]
    })

    for (const infoLine of this.extendedNode.getElementsByClassName("infoLine")) {
      const field = infoLine.dataset.info
      const opts = {
        max:infoLine.dataset.max,
        min:infoLine.dataset.min
      }
      sparkline.sparkline(infoLine.getElementsByTagName("svg")[0], historyData[field], opts)
      infoLine.getElementsByClassName("current")[0].textContent = formatNumber(historyData[field][historyData[field].length - 1], infoLine.dataset.fractionDigits)
    }
  }

  update() {
    if (this.expanded) return this.updateExpanded()

    let historyData = this.history.map( x => this.getRSSI(x))
    sparkline.sparkline(this.radioNode.querySelector(".sparkline"), historyData, {max:-30, min:-120})

    if (this.history.length > 1) {
      const node = this.radioNode.querySelector("[data-field='rssi']")
      node.textContent = formatNumber(this.getRSSI(this.history[this.history.length - 1]), 2)
    }

    this.radioNode.classList.remove("simple")
  }

  handleSyncCompleted(message) {
    if (!message) return
    this.setLead(message.roam.currentId == this.device.id)
    this.radioNode.classList.remove("simple")
  }

  handleMissionStep(message) {
    if (message.type === "MISSION_ROAM") {
      this.setLead(message.currentId == this.device.id)
    } else if (message.type === "SKYLINK_ADV_STATUS") {
      if (this.device.type === "ARS") {
        if (!message.data.local.isLead) return
      } else {
        if (message.data.localSource.deviceId !== this.device.id) return
        this.setLead(message.data.local.isLead)
      }
      this.history.push(message)
        if (this.history.length > HISTORY_COUNT) {
          this.history = this.history.slice(-HISTORY_COUNT)
        }
    }
    this.update()
  }

  handleMissionIndexJump(index) {
    this.history = []
    
    let foundLead = false
    // Search backwards for a roam
    for (let i = index; i >= 0; i--) {
      const entry = this.mission.history[i]

      if (entry.type !== "SKYLINK_ADV_STATUS") continue

      if (!foundLead) {
        foundLead = true
        this.setLead(entry.data.local.isLead)
      }

      if (!entry.data || !entry.data.localSource) {
        console.error("HERE")
      }

      if (this.device.type === "ARS") {
        if (!entry.data.local.isLead) continue
      } else {
        if (entry.data.localSource.deviceId !== this.device.id) continue
      }

      if (this.history.length < HISTORY_COUNT) {
        this.history.unshift(entry)
      } else if (foundLead) {
        break
      }
    }

    this.update()
  }

  handleMissionHistoryLoad() {
    this.handleMissionIndexJump(this.mission.replayInfo.currentIndex - 1)
  }

  cleanup() {
    super.cleanup()
    adminFeed.unregister('device', this.device.id, this.handleDeviceUpdated)
  }

}